import React, {useEffect, useRef, useState} from 'react';
import cx from 'clsx';
import s from './CartApp.scss';
import {useControllerProps} from '../../../../domain/controllers/ControllerContext';
import {withResizeObserver} from './HOC/withResizeObserver';
import {withSentryErrorBoundary} from '@wix/native-components-infra';
import {CART_DSN} from '@wix/wixstores-client-storefront-sdk';
import './vars.scss';
import {ErrorToast} from '../../../../common/components/ErrorToast/ErrorToast';
import {useEnvironment, useExperiments} from '@wix/yoshi-flow-editor';
import {ToastPlacement} from 'wix-ui-tpa';
import {SlotPlaceHolder} from '../../../../common/components/SlotPlaceHolder/SlotPlaceHolder';
import {SlotsMap} from '../../../../common/constants';
import {CartLayout} from './partials/CartLayout';
import {SPECS} from '../../../../domain/specs';

export enum CartAppDataHook {
  root = 'CartAppDataHook.root',
}

const CartApp = () => {
  const {isResponsive, isLoading, cartStore, cashierExpressStore} = useControllerProps();
  const viewerVersion = isResponsive ? 'viewer_x' : 'viewer_classic';
  const {isMobile} = useEnvironment();
  const main = s.main;
  const classNames = cx(main, s[viewerVersion], 'cart');
  const mainRef = useRef<HTMLElement>(null);
  const [loaded, setLoaded] = useState(false);
  const shouldShowSkeleton = !loaded;
  useEffect(() => {
    setLoaded(!isLoading);
  }, [isLoading]);

  const {experiments} = useExperiments();

  useEffect(() => {
    if (!experiments.enabled(SPECS.StopFocusOnCart)) {
      if (loaded && mainRef?.current) {
        mainRef.current.focus();
        cashierExpressStore?.handlePaymentMethodError();
      }
    } else if (loaded) {
      cashierExpressStore?.handlePaymentMethodError();
    }
  }, [loaded]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={s.container}>
      <main
        data-hook={CartAppDataHook.root}
        className={classNames}
        data-wix-cart
        ref={experiments.enabled(SPECS.StopFocusOnCart) ? undefined : mainRef}
        tabIndex={-1}>
        {!shouldShowSkeleton && (
          <div className={!isMobile ? cx(s.toastContainer) : null}>
            <ErrorToast placement={isMobile ? ToastPlacement.bottomFullWidth : ToastPlacement.inline} />
          </div>
        )}
        <CartLayout shouldShowSkeleton={shouldShowSkeleton} />
        {!shouldShowSkeleton && cartStore?.AddSlotToCartPage && <SlotPlaceHolder slotId={SlotsMap.mainBottom} />}
      </main>
    </div>
  );
};

// eslint-disable-next-line import/no-default-export
export default withSentryErrorBoundary(withResizeObserver(CartApp), {
  dsn: CART_DSN,
  config: {environment: 'Native Component'},
});
